import Styles from './ProgressBar.module.scss';

const ProgressBar = ({ value }) => {
  return <div className={Styles.progressBar} style={{ width: `${value}%` }} />;
};

ProgressBar.propTypes = {};

export default ProgressBar;
